/**
 * Client helper for the password-change-status API.
 * All 60-day / expiry policy logic lives in the backend; the client only reads requiresChange.
 */

/**
 * @param {number} userId
 * @param {string} userRole - e.g. "distributor", "wholesaler", "admin"
 * @returns {Promise<{ requiresChange: boolean, lastChangedAt: string | null, reason: string }>}
 */
export async function getPasswordChangeStatus(userId, userRole) {
    const res = await fetch('/api/User/password-change-status', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ UserId: parseInt(userId, 10), UserRole: userRole || '' }),
    });
    if (!res.ok) throw new Error('Failed to load password change status.');
    return res.json();
}

/** Normalize the camelCase / PascalCase API response (server returns PascalCase from C# JSON). */
export function passwordChangeRequiresChange(status) {
    if (!status || typeof status !== 'object') return false;
    return status.requiresChange === true || status.RequiresChange === true;
}
